import React from 'react';
import s from './MobileFooter.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import { PRODUCT } from '../mobile-constant';
import classNames from 'classnames';
import { ClientOffering } from '../../../services/client-offering';
import { biLogger } from '../../../globals';

interface MobileFooterProps {
  clientOffering: ClientOffering;
  selectedProduct: number;
  onClickOnUpgrade: () => void;
}

export const MobileFooter: React.FunctionComponent<MobileFooterProps> = (
  props: MobileFooterProps,
) => {
  const { t } = useTranslation();
  const { selectedProduct, clientOffering } = props;

  const products = clientOffering.getProductList(t('package.free.name'));
  const product = products[selectedProduct];
  const priceCurrency = clientOffering.getCurrency();
  const productPrice = `${priceCurrency}${product.price}${t('mobile.aMonth')}`;
  const productCode = product.name;
  const productIndex = clientOffering.getCurrentProductIndex();
  const isCurrentPlanSelected = productIndex === selectedProduct;
  const isDowngradeSelected = productIndex < selectedProduct;
  const { productId } = product;

  const selectedClassName = (index: number) => ({
    [s.isProductLimited]: index === PRODUCT.FREE,
    [s.isProductBasic]: index === PRODUCT.BASIC,
    [s.isProductPro]: index === PRODUCT.PRO,
    [s.isProductUnlimited]: index === PRODUCT.UNLIMITED,
  });

  const handleUpgradeClick = () => {
    biLogger.cycleOpen({ packageId: productId, package_name: productCode });
    props.onClickOnUpgrade();
  };

  const renderUpgradeButton = () => {
    return (
      <div className={s.upgradeButton}>
        <div className={s.returnTerms} data-hook="mobile-footer-upgrade-terms">
          {t('mobile.footer.returnTerm')}
        </div>
        <div
          className={classNames(
            s.selectButton,
            selectedClassName(selectedProduct),
          )}
          data-hook="mobile-footer-upgrade-button-text"
          onClick={() => handleUpgradeClick()}
        >
          {t('mobile.footer.button', { productCode, productPrice })}
        </div>
      </div>
    );
  };

  const renderCurrentPlan = () => {
    return (
      <div>
        <div
          className={s.currentPlan}
          data-hook="mobile-footer-current-product-message"
        >
          {t('mobile.footer.currentPlan')}
        </div>
        <div
          className={s.selectMessage}
          data-hook="mobile-footer-upgrade-message"
        >
          {t('mobile.footer.message')}
        </div>
      </div>
    );
  };

  const renderDowngradePlan = () => {
    return (
      <div>
        <div
          className={s.selectMessageDowngrade}
          data-hook="mobile-footer-upgrade-message"
        >
          {t('mobile.footer.message')}
        </div>
      </div>
    );
  };

  return (
    <div className={s.strip} data-hook="mobile-footer">
      {isCurrentPlanSelected
        ? renderCurrentPlan()
        : isDowngradeSelected
        ? renderDowngradePlan()
        : renderUpgradeButton()}
    </div>
  );
};

export default MobileFooter;
